import data from '@emoji-mart/data';

interface EmojiSkin {
	native: string;
}

interface EmojiData {
	skins: EmojiSkin[];
}

const shortcodeRegex = /(:[a-z0-9+_-]+:)(:skin-tone-\d+:)?/g;

// This is not an ideal way to do this. However, unfortuantely the front-end and back-end use two Emoji libraries
// and there are discrepancies between them as to the shortcodes used for some tokens. Until we settle on a unified
// Emoji lib we'll need to manually account for differences.
const manualAliases = {
	hugging: 'hugging_face',
	rofl: 'rolling_on_the_floor_laughing',
} as Record<string, string>;

const registry = (data as any).emojis as unknown as Record<string, EmojiData>;
const aliases = (data as any).aliases as unknown as Record<string, string>;

const getEmojiData = (shortcode: string) => {
	const clean = shortcode.replaceAll(':', '');

	const checks = new Set([clean]);

	if (/[_-]/.test(clean)) {
		checks.add(clean.replaceAll('-', '_'));
		checks.add(clean.replaceAll('_', '-'));
	}

	[aliases, manualAliases].forEach((alias) => {
		if (clean in alias) {
			checks.add(alias[clean] as string);
		}
	});

	for (const name of checks) {
		if (registry[name]) {
			return registry[name];
		}
	}
};

const getReplacement = (match: RegExpMatchArray, data: EmojiData): string => {
	const index = match[2] ? +match[2].replaceAll(':', '').slice(-1) : 0;
	return data.skins[index]?.native || data.skins[0].native;
};

export const populateEmojis = (text: string): string => {
	return [...text.matchAll(shortcodeRegex)].reduce((acc, match) => {
		const data = getEmojiData(match[1]);
		return data ? acc.replaceAll(match[0], getReplacement(match, data)) : acc;
	}, text);
};
